import { FormattedVerificationTransactionDetailsClaim, VerificationTransactionDetailsClaim } from "@idw-types/data/verification-transaction-details";

export const formatVerificationTransactionDetailsClaims = (
    claims: Array<VerificationTransactionDetailsClaim>
): Array<FormattedVerificationTransactionDetailsClaim> => {
    return claims.map(claim => formatVerificationTransactionDetailsClaim(claim));
};

export const formatVerificationTransactionDetailsClaim = (
    claim: VerificationTransactionDetailsClaim
): FormattedVerificationTransactionDetailsClaim => {
    let effectiveDate = null;
    if (claim.effectiveDate) {
        effectiveDate = new Date(parseInt(claim.effectiveDate));
    }

    let expirationDate = null;
    if (claim.expirationDate) {
        expirationDate = new Date(parseInt(claim.expirationDate));
    }


    return {
        apiKey: claim.apiKey,
        attempt: claim.attempt,
        claimStatus: claim.claimStatus,
        claimType: claim.claimType,
        effectiveDate: effectiveDate,
        expirationDate: expirationDate,
        id: claim.id,
        rpServiceName: claim.rpServiceName,
        serviceOfferingName: claim.serviceOfferingName
    };
};